module.exports = __webpack_public_path__ + "static/assets/1d7cef94ff54c14845479a1d7e3c3d95.png";